import { useRef } from "react";
import { Link } from "react-router-dom";
import AnimeCard from "@/components/feature/AnimeCard";
import { animeList } from "@/mocks/anime";

export default function HotSection() {
  const scroller = useRef<HTMLDivElement>(null);
  const hot = [...animeList].sort((a, b) => b.score - a.score).slice(0, 6);

  const scroll = (dir: number) => {
    scroller.current?.scrollBy({ left: dir * 300, behavior: "smooth" });
  };

  return (
    <section className="container-site py-10 md:py-14">
      <div className="mb-6 flex items-end justify-between gap-4">
        <div>
          <h2 className="flex items-center gap-2 font-heading text-2xl text-foreground-50 md:text-3xl">
            <i className="ri-fire-fill text-accent-500" />
            本周热门推荐
          </h2>
          <p className="mt-1 text-sm text-foreground-400">漫迷口碑之选，高分好评一网打尽</p>
        </div>
        <div className="flex items-center gap-2">
          <button onClick={() => scroll(-1)} aria-label="上一组" className="flex h-9 w-9 items-center justify-center rounded-md border border-background-700 text-foreground-300 transition-colors hover:border-primary-500 hover:text-primary-400">
            <i className="ri-arrow-left-line" />
          </button>
          <button onClick={() => scroll(1)} aria-label="下一组" className="flex h-9 w-9 items-center justify-center rounded-md border border-background-700 text-foreground-300 transition-colors hover:border-primary-500 hover:text-primary-400">
            <i className="ri-arrow-right-line" />
          </button>
        </div>
      </div>

      <div ref={scroller} className="no-scrollbar flex snap-x gap-4 overflow-x-auto pb-2">
        {hot.map((a, i) => (
          <div key={a.id} className="w-[240px] shrink-0 snap-start sm:w-[260px]">
            <AnimeCard anime={a} rank={i + 1} />
          </div>
        ))}
      </div>

      <div className="mt-6 flex justify-center">
        <Link to="/list" className="btn-ghost">
          查看全部番剧
          <i className="ri-arrow-right-line ml-1" />
        </Link>
      </div>
    </section>
  );
}